(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const targets = new Set();
  const visible = new WeakSet();
  let paused = false;
  try { paused = localStorage.getItem('ebd-motion-paused') === 'true'; } catch (_) {}
  const enabled = () => !paused && !reduced.matches && !document.hidden;
  const updateTarget = element => element.classList.toggle('eb-motion-running', enabled() && visible.has(element));
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
      updateTarget(entry.target);
    });
  }, { threshold: 0 }) : null;
  function watch(element, className) {
    if (!element || targets.has(element)) return;
    if (className) element.classList.add(className);
    targets.add(element);
    if (observer) observer.observe(element);
    else { visible.add(element); updateTarget(element); }
  }
  function update() {
    document.body.dataset.ebdMotion = paused || reduced.matches ? 'paused' : 'running';
    targets.forEach(element => {
      if (!element.isConnected) { observer?.unobserve(element); targets.delete(element); }
      else updateTarget(element);
    });
    const button = document.querySelector('.eb-motion-toggle');
    if (button) {
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? button.dataset.resume : button.dataset.pause;
    }
  }
  function initialize(root = document) {
    root.querySelectorAll('.eb-blue-launch-tee>a:first-child,.eb-blue-hero>a,.eb-blue-seasonal>div>a:not(.eb-blue-pink-art),.eb-blue-approved-edits>div>a:first-child,.eb-blue-collection-vest').forEach(frame => {
      const surface = Array.from(frame.children).find(child => child.matches('img,picture,.ebd-gear-artwork'));
      if (!surface) return;
      frame.classList.add('eb-motion-frame');
      watch(surface, 'eb-motion-surface');
    });
    root.querySelectorAll('.eb-editorial-art>img,.eb-editorial-art>svg,.eb-editorial-art>.eb-editorial-pair,.eb-editorial-art>.eb-editorial-details,.eb-world-models,.eb-blue-pink-art>img,.eb-blue-sweats-art>img,.eb-blue-hat>img,.eb-blue-about-teaser>img,.eb-blue-about-hero>img,.eb-blue-model-art>img,.eb-id-sketch').forEach(element => watch(element, 'eb-motion-cutout'));
    const footer = document.querySelector('footer');
    const labels = document.querySelector('[data-ebd-motion-labels]');
    if (footer && labels && !document.querySelector('.eb-motion-toggle')) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'eb-motion-toggle';
      button.dataset.pause = labels.dataset.pause;
      button.dataset.resume = labels.dataset.resume;
      button.addEventListener('click', () => {
        paused = !paused;
        try { localStorage.setItem('ebd-motion-paused', String(paused)); } catch (_) {}
        update();
      });
      const container = footer.querySelector('.wrap') || footer;
      container.append(button);
    }
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(update));
  document.addEventListener('visibilitychange', update);
  reduced.addEventListener('change', update);
})();
